<script setup lang="ts">
import { useBranchSelectPrompt } from '../model/useBranchSelectPrompt'

// Стартовый промпт «Выберите филиал»: состояние и поведение — в композабле,
// представление — общая шторка UiStartPromptSheet (одна на все стартовые промпты).
const { isOpen, chooseLocation, dismiss } = useBranchSelectPrompt()
</script>

<template>
  <UiStartPromptSheet
    :open="isOpen"
    icon="i-heroicons-building-storefront-20-solid"
    subtitle="Где вы находитесь?"
    title="Выберите филиал"
    primary-label="Выбрать локацию"
    @primary="chooseLocation"
    @dismiss="dismiss"
  />
</template>
